import { get } from 'axios'
// import store from '@/store'
import store from './../../store/index.js'

const BASE_URL = store.state.api.baseUrl
const headers = { Authorization: `Bearer ${store.state.user.attributes.token}` }

function getProgramProgramSeasons (pIdProgram, pPage) {
    const URI = `${BASE_URL}/api/programs/${pIdProgram}/programSeasons?page=${pPage}`
    return get(URI, { headers })
}

export {
    getProgramProgramSeasons
}